<template>
  <v-container>
    <v-row justify="center" class="param-area" no-gutters>
      <v-col cols="10" xs="10" sm="8" md="8" lg="8">
        <TitleLabel :title="teamName" />
      </v-col>
    </v-row>
    <Alert :user-authority="userAuthority" :comment.sync="comment" :team-id="teamId" />
    <v-row justify="center" class="param-area" no-gutters>
      <v-col cols="12" xs="12" sm="5" md="5" lg="4" class="param">
        <TopParamWaterTemp :temp-val="latestWaterTemperature" @clickAction="openWTChart" />
      </v-col>
      <v-col cols="12" xs="12" sm="5" md="5" lg="4" class="param">
        <TopParamPh :ph-val="latestPh" @clickAction="openPHChart" />
      </v-col>
    </v-row>
    <v-row justify="center" no-gutters class="video-area">
      <v-col cols="12" xs="12" sm="10" md="10" lg="8">
        <v-row justify="center" no-gutters v-if="this.deviceName === 'pc'">
          <video-player ref="videoPlayer" :options="playerOptions" @ready="onPlayerReady" />
        </v-row>
        <v-row justify="center" no-gutters v-else>
          <video-player ref="videoPlayer" :options="spPlayerOptions" @ready="onPlayerReady" />
        </v-row>
      </v-col>
    </v-row>
    <v-col cols="12" xs="12" sm="10" md="10" lg="8">
      <v-overlay absolute :value="overlay" color="rgba(0,0,0,0)">
        <ChartCard
          @closeClickAction="closeChart"
          :fetched-data="selectedFetchedData"
          :quality-name="selectedQualityName"
        />
      </v-overlay>
    </v-col>
  </v-container>
</template>

<script>
import TitleLabel from "../Atoms/TitleLabel";
import Alert from "../Molecules/Alert";
import TopParamWaterTemp from "../Organisms/TopParamWaterTemp";
import TopParamPh from "../Organisms/TopParamPh";
import ChartCard from "../Organisms/ChartCard";
import errorHandle from "../../util/errorHandle.js";
import VideoPlayer from "@/components/VideoPlayer.vue";

export default {
  name: "Top",
  data: () => ({
    overlay: false,
    teamId: "",
    tankId: "",
    streamingUrl: "",
    accessToken: "",
    userAuthority: "",
    teamName: "",
    comment: "",
    fetchedWaterTemperatureRecords: [],
    fetchedPhRecords: [],
    selectedFetchedData: [],
    latestWaterTemperature: "",
    latestPh: "",
    selectedQualityName: "",
    playerOptions: {
      autoplay: true,
      controls: true,
      controlBar: {
        timeDivider: false,
        durationDisplay: false
      },
      html5: {
        hls: {
          overrideNative: true
        }
      },
      muted: "muted"
    },
    spPlayerOptions: {
      autoplay: false,
      controls: true,
      controlBar: {
        timeDivider: false,
        durationDisplay: false
      },
      html5: {
        hls: {
          overrideNative: true
        }
      }
    }
  }),
  props: [],
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    deviceName() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "sp";
        case "sm":
        case "md":
        case "lg":
        case "xl":
          return "pc";
        default:
          return "pc";
      }
    }
  },
  created() {
    this.initIcon();
    this.fetchInitialData();
    this.getTeams()
      .then(() => {
        this.fetchWaterTemperatureRecords();
        this.fetchPhRecords();
        const src = this.streamingUrl;
        this.playVideo(src);
      })
      .catch(error => {
        console.log("error", error);
      });
  },
  mounted() {},
  methods: {
    // API通信を行うのに必要な情報を取得する
    fetchInitialData() {
      const team_info = this.$store.getters["team/getTeamInfo"];
      this.teamId = team_info.teamId;

      const user_info = this.$store.getters["user/getUserInfo"];
      this.accessToken = user_info.accessToken;
      this.userAuthority = user_info.userAuthority;
    },
    initIcon() {
      this.$emit("initIcon");
    },
    openWTChart() {
      this.overlay = !this.overlay;
      this.selectedQualityName = "WT";
      this.enterChartData("WT");
    },
    openPHChart() {
      this.overlay = !this.overlay;
      this.selectedQualityName = "PH";
      this.enterChartData("PH");
    },
    closeChart() {
      this.overlay = false;
    },
    getTeams() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .get(`/api/teams?team_id=${this.teamId}`, header)
          .then(response => {
            this.teamName = response.data.teams[0].name;
            this.comment = response.data.teams[0].comment;
            this.tankId = response.data.teams[0].tank_id;
            this.streamingUrl = response.data.teams[0].live_url;
            resolve();
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.fetchInitialData();
                this.getTeams();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
      });
    },
    // 水温データを取得
    fetchWaterTemperatureRecords() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .get(`/api/water_temperature_records?tank_id=${this.tankId}`, header)
          .then(response => {
            this.fetchedWaterTemperatureRecords =
              response.data.water_temperature_records.reverse();
            if (!this.fetchedWaterTemperatureRecords.length) {
              return;
            }
            this.latestWaterTemperature = this.fetchedWaterTemperatureRecords[0].water_temperature;
            resolve();
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.fetchInitialData();
                this.fetchWaterTemperatureRecords().catch(error => {
                  console.log(error);
                });
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
                reject();
              });
            console.log(error);
          });
      });
    },
    // PHデータを取得
    fetchPhRecords() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .get(`/api/water_quality_records?tank_id=${this.tankId}`, header)
          .then(response => {
            this.fetchedPhRecords = response.data.water_quality_records.reverse();
            if (!this.fetchedPhRecords.length) {
              return;
            }
            this.latestPh = this.fetchedPhRecords[0].ph;
            resolve();
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.fetchInitialData();
                this.fetchPhRecords().catch(error => {
                  console.log(error);
                });
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
                reject();
              });
            console.log(error);
          });
      });
    },
    enterChartData(selectedQuality) {
      switch (selectedQuality) {
        case "WT":
          this.selectedFetchedData = this.fetchedWaterTemperatureRecords;
          break;
        case "PH":
          this.selectedFetchedData = this.fetchedPhRecords;
          break;
        default:
          console.log("該当チャートが存在しないため開くことができません");
          break;
      }
    },
    onPlayerReady() {
      this.player.play();
    },
    playVideo: function(source) {
      const video = {
        withCredentials: false,
        type: "application/x-mpegurl",
        src: source
      };
      this.player.reset(); // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
      this.player.src(video);
      // this.player.load()
      this.player.play();
    }
  },
  components: {
    TitleLabel,
    Alert,
    TopParamWaterTemp,
    TopParamPh,
    // StreamingTank,
    ChartCard,
    VideoPlayer
  },
  head: {
    title: {
      inner: "top"
    }
  }
};
</script>

<style scoped>
.param-area {
  padding: 20px 0 0 0;
}
.param {
  padding: 0 12px 0 12px;
}
.video-area {
  margin-top: 40px;
  margin-bottom: 60px;
}
</style>
